// extracted by mini-css-extract-plugin
module.exports = {"linkItemButton":"NavLinks_linkItemButton__qig7m"};